import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_cwuI2omWaqvE: {
	id: 'prd_cwuI22DEV2omWaqvE'
	ident: 'prd_cwuI2omWaqvE'
	sku: 'simple_premium_1w_4_15_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_4si0Q2DEV2zipXqNR'
			amount: 22
			amount_usd: 4.15
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 4.15
			discount: 17.85
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_rhJb02DEV2GsqM21n'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_cwuI2omWaqvE, SubscriptionProduct>
const prd_cwuI2omWaqvE = { ident: 'prd_cwuI2omWaqvE' } as typeof _prd_cwuI2omWaqvE

export default prd_cwuI2omWaqvE
